:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 0 0 calc(var(--spacer) * 2);
}

.json-viewer-container {
  position: relative;
  border: 1px solid var(--gz-loader-animation-bg);
  border-radius: calc(var(--spacer) * 0.5);
  padding: var(--spacer) calc(var(--spacer) * 0.5);
}

.copy-icon {
  width: 36px;
  position: absolute;
  top: var(--spacer);
  right: calc(var(--spacer) * 1.5);
}

.back-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: calc(var(--spacer) * -4);
  width: fit-content;

  ::part(button) {
    background-color: transparent !important;
    border: none !important;
  }

  ::part(svgIcon) {
    fill: var(--body-text-arrows-400);
    transition: all 0.3s ease 0s;
  }

  &:hover {
    ::part(button) {
      color: var(--chart-301-icon-buttons);
    }
  
    ::part(svgIcon) {
      fill: var(--chart-301-icon-buttons);
    }
  }
}
